import validateJSON from './jsonvalidation'

const getViewUrl = (meta, store) => {
  // console.log(meta)
  //   if (!meta || !meta.data || !store?.name) {
  //     console.log("returned 1")
  //     return ''
  //   }
  const Meta = validateJSON(meta).data
//   console.log(Meta)
  // Magento logic
  if (store?.type === 'magento') {
    if (Meta?.type === 'products' && Meta?.id) {
      return `https://${store.name}/catalog/product/view/id/${Meta?.id}`
    } else if (Meta?.type === 'collections' && Meta?.id) {
      return `https://${store.name}/catalog/product/view/id/${Meta?.id}`
    } else if (Meta?.type === 'pages' && Meta?.id) {
      return `https://${store.name}/cms/page/view/page_id/${Meta?.id}`
    }
  }

  // Shopify logic
  if (store?.type === 'shopify') {
    // console.log('shopify entered')
    let extractedId = ''
    let extractedstorename = ''
    if (Meta?.type === 'products' && Meta?.id) {
      extractedId = Meta.id.replace('gid://shopify/Product/', '')
      extractedstorename = store.name.replace('.myshopify.com', '')
      return `https://admin.shopify.com/store/${extractedstorename}/products/${extractedId}`
    } else if (Meta?.type === 'collections' && Meta?.id) {
      extractedId = Meta.id.replace('gid://shopify/Collection/', '')
      extractedstorename = store.name.replace('.myshopify.com', '')
      return `https://admin.shopify.com/store/${extractedstorename}/collections/${extractedId}`
    } else if (Meta?.type === 'pages' && Meta?.id) {
      extractedId = Meta.id.replace('gid://shopify/Page/', '')
      extractedstorename = store.name.replace('.myshopify.com', '')
      return `https://admin.shopify.com/store/${extractedstorename}/pages/${extractedId}`
    } else if (Meta?.type === 'articles' && Meta?.id) {
      extractedId = Meta.id.replace('gid://shopify/Article/', '')
      extractedstorename = store.name.replace('.myshopify.com', '')
      return `https://admin.shopify.com/store/${extractedstorename}/content/articles/${extractedId}`
    }
  }

  // Generic website URL
  if (Meta?.type === 'pages' && Meta?.url) {
    return Meta.url
  }

  return ''
}

export default getViewUrl
